import constants from 'constants/constants';
import { useQuery } from 'react-query';

import { getCommonObjectsList as queryFn } from 'api/endPoints/getCommonObjectsList';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCommonResources = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getCommonResources', params],
        queryFn: () => queryFn(params),
        staleTime: constants.MINUTE * 5,
    });
};

export interface QueryParams {
    objectsList: (keyof QueryResponse)[];
    projectId?: number;
}

export type IUser = {
    firstName: string;
    id: null;
    lastName: string;
    userName: string;
    imageName: string;
};

export type ITags = {
    id: number;
    name: string;
};

export interface QueryResponse {
    users?: IUser[];
    tags?: ITags;
}
